document.addEventListener('DOMContentLoaded', function () {
  var attempts = 0;
  var maxAttempts = 40; // ~12s max (40 * 300ms)

  var interval = setInterval(function () {
    attempts++;

    var ratingBox = document.querySelector('.unique-rating-stars-container');
    var reviewsSection = document.getElementById('reviews-body');

    // On attend que Trustoo ait injecté à la fois la barre de rating ET la section avis
    if (ratingBox && reviewsSection) {
      console.log('[RATING-SCROLL] Elements found, binding click');

      ratingBox.style.cursor = 'pointer';

      ratingBox.addEventListener('click', function () {
        // Petit offset pour éviter que le titre soit collé tout en haut
        var offset = 80; // px
        var rect = reviewsSection.getBoundingClientRect();
        var targetY = rect.top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      });

      clearInterval(interval);
    } else if (attempts >= maxAttempts) {
      console.log('[RATING-SCROLL] Elements not found, stop trying');
      clearInterval(interval);
    }
  }, 300);
});
